exports.documentTypes = {
  employeeDeactivateCsv: -2,
  employeeCsv: -1,
  payslip: 0,
  p60: 1,
  p45: 2,
  p11d: 3,
  getDocumentTypeName: function(v) {
    if (v == this.employeeDeactivateCsv) {
      return "Employee Deactivate CSV"
    }
    if (v == this.employeeCsv) {
      return "Employee CSV"
    }
    if (v == this.payslip) {
      return "Payslip"
    }
    if (v == this.p60) {
      return "P60"
    }
    if (v == this.p45) {
      return "P45"
    }
    if (v == this.p11d) {
      return "P11D"
    }
    return false
  },
  getDocumentTypes: function() {
    return [
      {
        typeId: -2,
        name: "Employee Deactivate CSV",
        bucket: "ess-employee-deactivation-csvs"
      },
      {
        typeId: -1,
        name: "Employee CSV",
        bucket: "ess-employee-csvs"
      },
      {
        typeId: 0,
        name: "Payslip",
        bucket: "ess-portal-payslips"
      },
      {
        typeId: 1,
        name: "P60",
        bucket: "ess-portal-p60s-euw2"
      },
      {
        typeId: 2,
        name: "P45",
        bucket: "ess-portal-p45s"
      },
      {
        typeId: 3,
        name: "P11D",
        bucket: "ess-portal-p11ds"
      },
      {
        typeId: 4,
        name: "Pension Letter",
        bucket: "ess-portal-pension-letters"
      },
    ]
  }
}
